var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"h-100",attrs:{"id":"account-transactions-filters","title":"Filters"}},[_c('FilterWidget',{model:{value:(_vm.filters),callback:function ($$v) {_vm.filters=$$v},expression:"filters"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }